import type { LanguageType } from '@/types/language';

import type { FaqEntry } from './faq';
import { HOME_FAQ_BY_LOCALE } from './homeFaq';
import { INDUSTRIAL_FAQ_BY_LOCALE } from './industrialFaq';
import { SAFETY_FAQ_BY_LOCALE } from './safetyFaq';

export const FAQ_PAGE_COPY = {
  ko: {
    title: '자주 묻는 질문',
    description:
      '소리 AI부터 솔루션 도입까지, 궁금한 내용을 한곳에서 확인하세요.',
    all: '전체',
    general: '디플리 · 소리 AI',
    search: '질문과 답변 검색',
    placeholder: '궁금한 내용을 검색하세요',
    clear: '검색어 지우기',
    categories: 'FAQ 주제',
    count: (count: number) => `${count}개의 질문`,
    empty: '검색 결과가 없습니다.',
    emptyHelp: '다른 검색어를 입력하거나 전체 질문을 확인해 보세요.',
    reset: '전체 질문 보기',
    contactTitle: '찾으시는 답변이 없나요?',
    contactDescription:
      '도입 환경과 궁금한 내용을 알려주시면 함께 확인하겠습니다.',
    contact: '문의하기',
    solution: '솔루션 자세히 보기',
  },
  en: {
    title: 'Frequently asked questions',
    description:
      'Find answers about sound AI, our solutions, and getting started—all in one place.',
    all: 'All',
    general: 'Deeply · Sound AI',
    search: 'Search questions and answers',
    placeholder: 'What would you like to know?',
    clear: 'Clear search',
    categories: 'FAQ topics',
    count: (count: number) => `${count} questions`,
    empty: 'No matching questions.',
    emptyHelp: 'Try a different search or browse all questions.',
    reset: 'View all questions',
    contactTitle: 'Still have a question?',
    contactDescription:
      'Tell us about your needs and where you plan to use our solutions.',
    contact: 'Contact us',
    solution: 'Explore the solution',
  },
} as const;

export function getFaqGroups(locale: LanguageType) {
  return [
    {
      id: 'general',
      title: FAQ_PAGE_COPY[locale].general,
      href: '/',
      entries: HOME_FAQ_BY_LOCALE[locale],
    },
    {
      id: 'industrial',
      title: 'Listen AI Industrial',
      href: '/solution/industrial',
      entries: INDUSTRIAL_FAQ_BY_LOCALE[locale],
    },
    {
      id: 'safety',
      title: 'Listen AI Safety',
      href: '/solution/safety',
      entries: SAFETY_FAQ_BY_LOCALE[locale],
    },
  ];
}

export function matchesFaq(entry: FaqEntry, query: string) {
  const normalize = (value: string) =>
    value.normalize('NFKC').toLocaleLowerCase().replace(/\s+/g, ' ').trim();
  const text = normalize(`${entry.question} ${entry.answer}`);
  return normalize(query)
    .split(' ')
    .every((term) => text.includes(term));
}
